{
  "slug": "iq-145-meaning",
  "title": "IQ 145 meaning: percentile and interpretation",
  "description": "What an IQ score of 145 may mean, its percentile, uncertainty, strengths, and misconceptions.",
  "category": "IQ score interpretation",
  "sections": [
    {
      "heading": "Where 145 sits",
      "paragraphs": [
        "On a mean-100, SD-15 scale, 145 is near about the 99.9th percentile and generally described as in an extreme upper tail. The report’s own norms take priority.",
        "A percentile is not the percentage answered correctly; it is a transformed comparison with an age-based norm group."
      ]
    },
    {
      "heading": "Profile and possible strengths",
      "paragraphs": [
        "A composite does not prescribe a personality. People with the same total can have different verbal, visual, memory, and speed profiles.",
        "Identify strengths from subtests, strategies, education, and real-world performance—not the total alone."
      ]
    },
    {
      "heading": "Uncertainty and misconceptions",
      "paragraphs": [
        "Read the result with a wider, ceiling-dependent interval depending on measurement precision. Sleep, anxiety, health, language, device, motivation, and practice can affect an attempt.",
        "The number does not determine worth, creativity, emotional maturity, diagnosis, or future success. Cutoffs are conventions, not natural boundaries."
      ]
    }
  ],
  "related": ["iq-score-ranges-explained", "how-is-iq-measured", "what-is-the-average-iq"],
  "sources": [],
  "faqs": [
    {
      "question": "Is 145 a good IQ?",
      "answer": "“Good” is not a judgment of a person. The score describes relative performance on selected tasks and requires context."
    },
    {
      "question": "Can the score change?",
      "answer": "Yes. Measurement error, development, health, practice, and different instruments can produce different results."
    }
  ],
  "summary": "What an IQ score of 145 may mean, its percentile, uncertainty, strengths, and misconceptions. Content reviewed 18 July 2026."
}
